export { default } from './MapQuickAccessMobileCities';
